import React from "react";
import { Button, NavHorizontal, NavItem } from "@flixbus/honeycomb-react";
import type { BucketSelectorProps } from "./BucketSelector.types";
import styles from "./BucketSelector.module.scss";

const BucketSelector: React.FC<BucketSelectorProps> = ({
  dimensionTypeName,
  dimensionValues,
  activeDimensionValue,
  onChange,
  onEditDimensionValues,
}) => (
  <div className={styles.container}>
    {dimensionTypeName && (
      <span className={styles.label}>{`${dimensionTypeName}:`}</span>
    )}
    {dimensionValues.length === 0 ? (
      <span className={styles.emptyValues}>No values selected</span>
    ) : (
      <NavHorizontal
        aria-label="Cost buckets"
        wrapper
        extraClasses={styles.tabs}
      >
        {dimensionValues.map((value) => (
          <NavItem
            key={value}
            onClick={() => onChange(value)}
            active={value === activeDimensionValue}
          >
            {value}
          </NavItem>
        ))}
      </NavHorizontal>
    )}
    {onEditDimensionValues && (
      <Button appearance="secondary" onClick={onEditDimensionValues}>
        Edit
      </Button>
    )}
  </div>
);

export default React.memo(BucketSelector);
